<template>
    <div class="l-element">
        <heading-form-label text="お名前" label="required" />
        <p class="m-text-comments is-caution is-mgb8">
            ※本人確認書類の名前と異なる部分があると審査で非承認になる場合があります。
        </p>
        <div class="c-input-name-wrap">
            <form-input-text
                type="text"
                name="family-name"
                v-model="familyName"
                :value="familyNameValue"
                placeholder="例）風流"
                length="50"
                @blur="blurFunc()"
                data-jest="input-family-name"
            />
            <form-input-text
                type="text"
                name="given-name"
                v-model="givenName"
                :value="givenNameValue"
                placeholder="例）花子"
                length="50"
                @blur="blurFunc()"
                data-jest="input-given-name"
            />
        </div>

        <p v-if="isEmptyFamilyName" class="m-text-comments is-caution" data-jest="error-text-family-name">姓を入力してください</p>
        <p v-else-if="isEmptyGivenName" class="m-text-comments is-caution" data-jest="error-text-given-name">名を入力してください</p>
        <p v-if="isIncludeSymbols" class="m-text-comments is-caution" data-jest="error-text-symbol">記号は入力できません</p>
    </div>
</template>

<script>
import HeadingFormLabel from "../atoms/HeadingFormLabel.vue";
import FormInputText from "../atoms/FormInputText.vue";

export default {
    name: "JhsFreeInputProfileItemUserName",
    components: { HeadingFormLabel, FormInputText},
    props: {
        /**
         * 姓が空か
         * blur時のバリデーション判定用
         */
        isEmptyFamilyName: {
            type: Boolean,
            required: true
        },
        /**
         * 名が空か
         * blur時のバリデーション判定用
         */
        isEmptyGivenName: {
            type: Boolean,
            required: true
        },
        /**
         * 記号が含まれているか
         */
        isIncludeSymbols: {
            type: Boolean,
            required: true
        },
        /**
         * blur時のfunction
         */
        blurFunc: {
            type: Function,
            required: true
        },
        /**
         * 姓のフォームの初期値
         */
        familyNameValue: {
            type: String,
            required: true,
        },
        /**
         * 名のフォームの初期値
         */
        givenNameValue: {
            type: String,
            required: true,
        }
    },
    emits: ['inputFamilyName', 'inputGivenName'],
    computed: {
        familyName: {
            get() {
                return this.familyNameValue
            },
            set(value) {
                return this.$emit('inputFamilyName', value)
            }
        },
        givenName: {
            get() {
                return this.givenNameValue
            },
            set(value) {
                return this.$emit("inputGivenName", value);
            }
        },
    },
}
</script>

<style scoped lang="scss">
    .c-input-name-wrap {
        display: flex;
        gap: 15px;
        justify-content: space-between;
        align-items: flex-start;
    }
</style>
